export default {
      id: "charge-usage",
      viewBox: "0 0 24 40",
      url: __webpack_public_path__ + "img/icons.svg#charge",
      toString: function () {
        return this.url;
      }
    }